import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TaskWorkspaceStore } from '../../../h3ml/state/task-workspace-store';
import { ClientFeedbackListComponent } from '../../../outputs/annotation/annotation-shared/toolbars/shape-list-and-tag-editor/feedback-list/client-issue-list.component';
import { ShapeFeedbackListComponent } from '../../../outputs/annotation/annotation-shared/toolbars/shape-list-and-tag-editor/feedback-list/shape-feedback-list.component';
import { AddEditClientFeedbackDialogComponent } from '../../../shared/feedback/add-edit-client-issue-dialog/add-edit-client-issue-dialog.component';
import { AddEditFeedbackDialogComponent } from '../../../shared/feedback/add-edit-feedback-dialog/add-edit-feedback-dialog.component';
import { ClientFeedbackDetailViewComponent } from '../../../shared/feedback/client-issue-detail-view/client-issue-detail-view.component';

@Component({
  selector: 'h3-cv-feedback-panel',
  templateUrl: './cv-feedback-panel.component.html',
  styleUrls: ['./cv-feedback-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ClientFeedbackListComponent,
    ShapeFeedbackListComponent,
    AddEditClientFeedbackDialogComponent,
    AddEditFeedbackDialogComponent,
    ClientFeedbackDetailViewComponent,
    CommonModule,
  ],
})
export class CvFeedbackPanelComponent {
  target$ = inject(TaskWorkspaceStore)('feedbackPopover')('target').$;
  feedbackType = inject(TaskWorkspaceStore).state().feedbackType;
}
